import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 兼容ie
import '@babel/polyfill'

// 引入ant-design
import './plugins/antDesign/index.js'

// 导航守卫
import './router/routerFilter.js'

// 全局配置
import config from './config/index.js'
Vue.prototype.$config = config

// 全局axios
import axios from 'axios'
Vue.prototype.$axios = axios

// 全局api
import api from './api'
Vue.prototype.$api = api

// 全局project.config
import * as projectConfig from './config/project.config.js'
Vue.prototype.$projectConfig = projectConfig

// 全局cookie
import cookie from 'js-cookie'
Vue.prototype.$cookie = cookie

// 全局filters
import filter from './filter'
for (const key in filter) {
  Vue.filter(key, filter[key])
}

// 全局工具
import * as utils from './utils/index.js'
Vue.prototype.$utils = utils

// 全局请求
import http from './http'
Vue.prototype.$http = http

// 覆盖样式
import './style/index.less'

// 国际化
import i18n from './i18n/index.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
